import { render } from "./AddGateway.vue?vue&type=template&id=49b4f31e&ts=true"
import script from "./AddGateway.vue?vue&type=script&lang=ts"
export * from "./AddGateway.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__